import { Box } from "@mui/material";
import { ReactNode } from "react";

export type Tab = {
  children?: ReactNode;
  index: number;
  value: number;
};

export default function TabSection(props: Tab) {
  const { children, value, index } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`solution-details-tabpanel-${index}`}
      aria-labelledby={`solution-details-tab-${index}`}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </Box>
  );
}
